import React from 'react';
import { Badge } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../../context/ThemeContext';
import Table from '../../../commonComponents/Table';
import { TableCard, TableHeader, TableTitle, ActionButton } from './Styles';
import type { EnhancedTableProps } from './types';

const EnhancedTable: React.FC<EnhancedTableProps> = ({
  data,
  columns,
  title,
  emptyMessage = 'No data available',
  onExport,
  loading = false,
}) => {
  const { isDarkMode } = useTheme();

  const tableColumns = columns.map((col, index) => ({
    title: col,
    dataIndex: col.toLowerCase().replace(/\s+/g, '_'),
    key: index,
    render: (value: any) => {
      if (typeof value === 'boolean') {
        return (
          <Badge
            status={value ? 'success' : 'error'}
            text={value ? 'Active' : 'Inactive'}
          />
        );
      }
      return value || 'N/A';
    },
  }));

  // Transform data to match column keys
  const tableData = data.map((item, index) => {
    const row: Record<string, any> = { key: index };
    columns.forEach((col) => {
      const key = col.toLowerCase().replace(/\s+/g, '_');
      // Get value from item using the column name as key
      row[key] = item[col] || 'N/A';
    });
    return row;
  });

  return (
    <TableCard>
      <TableHeader>
        <TableTitle level={4}>{title}</TableTitle>
        {onExport && (
          <ActionButton
            type="primary"
            icon={<FontAwesomeIcon icon={faFilePdf} />}
            onClick={onExport}
            size="small"
          >
            Export PDF
          </ActionButton>
        )}
      </TableHeader>
      <Table
        columns={tableColumns}
        dataSource={tableData.slice(0, 10)}
        rowKey="key"
        loading={loading}
        pagination={false}
        scroll={{ x: true, y: 600 }}
        emptyText={emptyMessage}
        emptyDescription={emptyMessage}
        headerBackgroundColor={isDarkMode ? '#1a202c' : '#F2F2F2'}
        removeVerticalBorders={true}
        thPadding="15px 10px"
        tdPadding="10px 10px"
        firstChildBorderRadius="8px"
        border="0"
        borderBottomLeftRight={true}
        theme={isDarkMode ? 'dark' : 'light'}
      />
    </TableCard>
  );
};

export default EnhancedTable;
